import React from "react";
import { useTranslation } from "react-i18next";

import { getDisplayedAmount } from "@utils";
import { AccStatementBetSlipEventInOffer } from "@data-types/account-statement/AccountStatementBetSlip";

export function AdditionalGainBonus(props: {
	slipDetails: AccStatementBetSlipEventInOffer;
}) {
	const t = useTranslation().t;

	if (
		props.slipDetails.gainBonusPercentage == null ||
		props.slipDetails.gainBonus == 0
	) {
		return null;
	}

	return (
		<tr className="table--bets__tr">
			<td className="table--bets__dd">
				{t<string>("ACC_STATEMENT.BET_DETAILS.ADDITIONAL_GAIN_BONUS", {
					0: props.slipDetails.gainBonusPercentage.toFixed(2),
				})}
			</td>
			<td className="table--bets__dd">
				+ {getDisplayedAmount(props.slipDetails.gainBonus || 0, "", 0)}
			</td>
		</tr>
	);
}
